import { render, staticRenderFns } from "./AddonBoxProduct.vue?vue&type=template&id=47478dd2&scoped=true&"
import script from "./AddonBoxProduct.vue?vue&type=script&lang=js&"
export * from "./AddonBoxProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddonBoxProduct.vue?vue&type=style&index=0&id=47478dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47478dd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47478dd2')) {
      api.createRecord('47478dd2', component.options)
    } else {
      api.reload('47478dd2', component.options)
    }
    module.hot.accept("./AddonBoxProduct.vue?vue&type=template&id=47478dd2&scoped=true&", function () {
      api.rerender('47478dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/AddonBoxProduct.vue"
export default component.exports